import React, {useContext, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import * as constants from "../../../Panel/common/Constants";
import PageProvider from "../../../Page/PageContext";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function SelectedLanguages() {
    const classes = useStyles();
    const {settings} = useContext(PageProvider);
    const [languages, setLanguage] = React.useState([]);

    let flags = {el:"/app/greece-flag-round.png",en:"/app/united-kingdom-flag-round.png"}

    useEffect(() => {
        window.axios.post(constants.LocalUrl + '/data/getLanguages').then((response) => {
            setLanguage(response.data)
        })
    },[])

    const selectedLanguageKeys = settings?.languages ? Object.keys(settings.languages) : [];

    return (
        <div>
        <List className={classes.root}>
            {selectedLanguageKeys.map((value) => {
                const labelId = `selected-language-label-${value}`;

                if (!languages[value]) return null;

                return (
                    <ListItem className="wizard_language_list" key={value} role={undefined} dense>
                        <ListItemText id={labelId} primary={languages[value]} style={{fontSize:"16px"}}/>
                        <ListItemSecondaryAction>
                            <img src={flags[value]} height="28px" width="28px" alt=""/>
                        </ListItemSecondaryAction>
                    </ListItem>
                );
            })}
        </List>
        </div>
    );
}
